import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core'
import Dialog, { DialogProps } from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import classNames from 'classnames'
import { ReactNode, useEffect } from 'react'

import Button from '@/components/button'
import { useTimeLeft } from '@/hooks/use-time-left'

import { useStyles } from './styles'

export interface AlertDialogProps {
  icon: ReactNode
  title: string
  subtitle: string
  items?: string[]
  variant: 'error' | 'success' | 'warning'
  open: boolean
  handleConfirm?: () => void
  confirm?: string
  handleCancel?: () => void
  cancel?: string
  loading?: boolean
  autoClose?: boolean
  timeToClose?: number
  handleClose?: DialogProps['onClose']
  dialogActionsClassname?: string
}

export default function AlertDialog({
  icon,
  title,
  subtitle,
  items,
  variant,
  handleConfirm,
  confirm,
  handleCancel,
  cancel,
  open,
  loading,
  autoClose = false,
  timeToClose = 3,
  handleClose,
  dialogActionsClassname,
}: AlertDialogProps) {
  const classes = useStyles()

  const { setTimeLeft } = useTimeLeft(() => {
    handleConfirm?.()
  })

  const onCloseDefault = () => {
    if (!loading)
      if (handleCancel) handleCancel()
      else if (handleConfirm) handleConfirm()
  }

  const onClose = handleClose || onCloseDefault

  useEffect(() => {
    if (autoClose) {
      setTimeLeft(timeToClose)
    }
  }, [autoClose])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classNames(classes.main, classes[variant])}
    >
      <DialogTitle id='alert-dialog-title' disableTypography>
        {icon}
        <Typography variant={'h3'}>{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant={'body2'}>{subtitle}</Typography>
        <List>
          {items?.map((item) => (
            <ListItem disableGutters key={item}>
              <ListItemIcon>&#x2022;</ListItemIcon>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions
        classes={{
          root: classNames(classes.dialogActions, dialogActionsClassname),
        }}
      >
        {handleCancel && (
          <Button
            onClick={() => !loading && handleCancel()}
            labelOnly
            disabled={loading}
          >
            {cancel || 'Cancelar'}
          </Button>
        )}

        {handleConfirm && confirm && (
          <Button loading={loading} onClick={handleConfirm} outlined redBorder>
            {confirm}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
